module.exports = __webpack_public_path__ + "static/img/qItem3-img8.0d2daf8.png";


//////////////////
// WEBPACK FOOTER
// ./static/about/qItem3-img8.png
// module id = djBL
// module chunks = 1